import GenerateCondit, { Condit } from '@/models/GenerateCondit';
import { getToDay } from '@/models/GenerateCondit/Interrelated';

const paramsForm = {
  provinceArea: undefined, //  { name: '浙江经营本部' },
  dateRange: getToDay()
}
export default {
  namespace: 'staystoretop',
  state: {
    searchParams: { ...paramsForm },
  },

  effects: {
    *getData(_, { call, put, select }) {
      const { searchParams } = yield select(({ staystoretop }) => staystoretop)
      const { provinceArea, dateRange } = searchParams
      const condit = new Condit({
        startDate: dateRange[0],
        endDate: dateRange[1]
      })
      const gc = new GenerateCondit(condit)
      gc.scanProvinceArea = provinceArea?.name
      const conf = gc.converCondit()
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
